module.exports = __webpack_public_path__ + "static/media/Amazon.24b36e70.png";